<template>
  <section class="section">
    <content-container>
      <div class="content-wrapper">
        <h2 class="title">{{ title }}</h2>
        <p v-if="description" class="description">{{ description }}</p>
      </div>
      <div class="small-card-list-wrapper">
        <ul class="small-card-list">
          <li v-for="card in cards" :key="card.itemId" class="small-card-list-item">
            <menu-card
              @editItem="$emit('showAddItemModal', card.itemId)"
              :name="card.name"
              :price="card.price"
              :description="card.description"
              :allergyIcons="card.allergyIcons"
              :image="card.image"
              :vegetarian="card.vegetarian"
              :vegan="card.vegan"
              :glutenFree="card.glutenFree"
              :spicy="card.spicy"
              :isAlcohol="card.isAlcohol"
            />
          </li>
        </ul>
      </div>
    </content-container>
  </section>
</template>

<script>
import MenuCard from './MenuCard.vue'
import ContentContainer from './ContentContainer.vue'

export default {
  name: 'MenuCardList',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    description: String,
  },
  components: {
    MenuCard,
    ContentContainer,
  },
}
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: $section-spacing;
}

.title {
  font-weight: 900;
  font-size: 18px;
  margin-bottom: 0;
  text-align: left;
  cursor: pointer;
}

.description {
  font-size: 14px;
}

.small-card-list-wrapper {
  padding: 3px 0;
}

.small-card-list {
  display: flex;
  flex-wrap: wrap;
}

.small-card-list-item {
  margin-top: 15px;
  max-width: 100%;
  width: 100%;

  @media (min-width: $tabletPortrait) {
    max-width: 50%;
    padding-right: 20px;
  }

  @media (min-width: $tabletLandscape) {
    max-width: 33%;
  }
}
</style>
